import { ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import { table2excel } from '@/utils/table2Excel'

export default function commonMixin(): any {
	//获取store对象
	let store: any = useStore()
	//获取router对象
	let router: any = useRouter()
	//获取router对象
	let route: any = useRoute()
	// 配置
	let webConfig = JSON.parse(sessionStorage.getItem('config') as string)
	// 获取用户信息
	let user = sessionStorage.getItem('user') as string

	return {
		webConfig,
		store,
		route,
		router,
		user
	}
}

// 弹框混入模块
export function modalMixin(): any {
	let verifyModalRef: any = ref(null) // 审核弹框组件el
	let verifyModalData = ref({}) // 审核弹框数据

	let exportModalRef: any = ref(null) // 导出弹框el
	let exportDataSource = ref<any[]>([]) // 导出弹框数据

	let videoModalRef: any = ref(null) // 视频弹框el
	let videoModalData = ref({}) // 视频弹框数据
	
	let imgPreviewModalRef: any = ref(null) // 图片预览el
	let imgPreviewModalData = ref({}) // 图片预览数据

	let deviceInfoModalRef: any = ref(null) // 
	let deviceInfoData = ref({}) //

	// 处理导出操作
	async function execExport(source, handler, config) {
		let { columns, dataSource } = source // 原始数据
		let { filter, calc } = handler // filter:筛选条件 calc:数据处理
		let { size, excelName } = config // excel文件配置 size:导出excel条数 excelName：导出excel文件名
		let filterColumns = columns.filter(f => filter?.indexOf(f.dataIndex) > -1)
		let excelTitle = filterColumns.map(m => m.title) // 导出excel表头
		let excelDataSource = dataSource.slice(0, size || 500)?.map((m: any) => {
			let item: any = {}
			filterColumns.forEach((n: any) => {
				if (calc) {
					Object.assign(item, calc(m, n)) // 自定义数据处理
				} else {
					item[n.dataIndex] = m[n.dataIndex]
				}
			})
			return Object.values(item)
		})
		// 导出excel
		table2excel([[excelTitle, ...excelDataSource], [], excelName])
	}

	return {
		verifyModalRef,
		verifyModalData,
		exportModalRef,
		exportDataSource,
		videoModalRef,
		videoModalData,
		imgPreviewModalRef,
		imgPreviewModalData,
		deviceInfoModalRef,
		deviceInfoData,
		execExport,
	}
}
